<template>
  <section class="carousel">
    <div class="row">
      <div class="images col-8">
        <div class="overflow-image">
          <div class="loader position-center"></div>
          <template v-if="!loading">
            <div
              class="image"
              :class="setupClass(index)"
              v-for="(imgSpecs, index) in images"
              :style="{
                background: 'url(' + imgSpecs.splash + ')',
                'background-position': 'center center',
                'background-size': 'cover',
              }"
              :key="imgSpecs.id"
            >
              <img v-if="imgSpecs.url" :src="imgSpecs.url" alt="" class="hide" />
            </div>
          </template>
          <div class="loader position-center" v-else></div>
        </div>
      </div>
      <div class="text col-4">
        <h1>Dernières <strong>Réalisations</strong></h1>
        <transition name="fade" mode="out-in">
          <div class="image-infos" :key="displayTitle + displayLocation">
            <h2>{{ displayTitle }}</h2>
            <p>{{ displayLocation }}</p>
          </div>
        </transition>
        <div class="actions">
          <div>
            <button class="arrow arrow-left" @click="updateIndex(-1)">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="451.846px"
                height="451.847px"
                viewBox="0 0 451.846 451.847"
                style="enable-background:new 0 0 451.846 451.847;"
              >
                <path
                  d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
                />
              </svg>
            </button>
          </div>
          <div>
            <button class="arrow arrow-right" @click="updateIndex(1)">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                width="451.846px"
                height="451.847px"
                viewBox="0 0 451.846 451.847"
                style="enable-background:new 0 0 451.846 451.847;"
              >
                <path
                  d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
                />
              </svg>
            </button>
          </div>
        </div>
        <a class="special-cta" href="#realisations" v-smooth-scroll>Plus de réalisations</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    images: Array,
    default: [],
  },
  data() {
    return {
      loading: false,
      currentIndex: 1,
      previousIndex: -1,
    };
  },
  watch: {
    images() {
      this.currentIndex = 0;
    },
  },
  created() {
    this.setLoop();
  },
  methods: {
    setupClass(index) {
      if (index === this.previousIndex) {
        return "previous-image";
      } else if (index === this.currentIndex) {
        return "current-image";
      }
    },
    setLoop() {
      this.interval = setInterval(() => {
        this.previousIndex = this.currentIndex;
        this.currentIndex = ++this.currentIndex % this.imgsNumber;
      }, 5000);
    },
    updateIndex(sign) {
      clearInterval(this.interval);
      this.previousIndex = this.currentIndex;
      if (sign === 1) {
        this.currentIndex = (this.currentIndex + 1) % this.imgsNumber;
      } else if (sign === -1) {
        this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.imgsNumber - 1;
      }
      this.setLoop();
    },
  },
  computed: {
    imgsNumber() {
      return this.images.length;
    },
    displayTitle() {
      if (this.images.length && this.images[this.currentIndex] && this.images[this.currentIndex].title)
        return this.images[this.currentIndex].title;
      return "-";
    },
    displayLocation() {
      if (this.images.length && this.images[this.currentIndex] && this.images[this.currentIndex].location)
        return this.images[this.currentIndex].location;
      return "-";
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
